/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { guidFor } from "@ember/object/internals";
import Component from "@glimmer/component";
import { modifier } from "ember-modifier";
import jQuery from "jquery";

type Value = Record<string, any> | Array<string>;
interface Settings {
  onChange?: (value: Value) => unknown;
}
type Guid = ReturnType<typeof guidFor>;

interface Signature {
  Element: HTMLDivElement;
  Args: {
    settings?: Settings;
    selected: Value;
    id?: string;
  };
}

export default class FuiDropdownComponent extends Component<Signature> {
  valuesMap = new Map<Value, Guid | undefined>();

  @action
  _triggerChange(e: HTMLElement): void {
    // We need to call this property so that ember-modifier can execute the function when it is updated
    /* eslint-disable-next-line @typescript-eslint/no-unused-expressions */
    this.args.selected;
    jQuery(e).data().moduleDropdown.trigger.change();
  }

  triggerChange = modifier(this._triggerChange);

  @action
  registerValue(value: Value): void {
    this.valuesMap.set(value, this.valueMapper(value));
  }

  valueMapper(value: Value): Guid | string | undefined {
    if (value instanceof Array) {
      return value
        .map(i => {
          return typeof i === "string" ? i : guidFor(i);
        })
        .join(",");
    }

    return typeof value === "string" ? value : guidFor(value);
  }

  get selected(): Guid | undefined {
    return this.valueMapper(this.args.selected);
  }

  get initialOnChange(): NonNullable<
    Signature["Args"]["settings"]
  >["onChange"] {
    if (!this.args.settings) return undefined;

    return this.args.settings.onChange;
  }

  get settings(): Settings {
    const newOnChangeSetting: { onChange?: (guid: Guid) => unknown } = {};
    if (this.onChangeFromGuid)
      newOnChangeSetting.onChange = this.onChangeFromGuid;

    // replace the `onChange` provided in the @settings argument with the same method,
    // but this new one receives a Guid instead
    return Object.assign({}, this.args.settings, newOnChangeSetting);
  }

  get onChangeFromGuid(): ((guid: Guid) => unknown) | undefined {
    if (!this.initialOnChange) return undefined;

    const initialOnChange = this.initialOnChange;

    return (guid: Guid) => {
      const newValue = this.getValueFromGuid(guid);

      if (!newValue) {
        console.log(`No value found for guid ${guid}`);
        return;
      }

      initialOnChange(newValue);
    };
  }

  private getValueFromGuid(guid: Guid): Value | undefined {
    const guidAsArr = guid.split(",");
    const tuple = [...this.valuesMap].find(t =>
      guidAsArr.find(guid => guid === t[1])
    );
    if (!tuple) return undefined;

    return tuple[0];
  }
}
